import { useContext, useState, createContext, useEffect } from 'react';
import type { PropsWithChildren } from 'react';
import { IAssignment } from '../types/IAssignment';
import { getAssignments } from '../data/assignments';
import { IApiContext } from '../types/Shared';
import { ICourse } from '../types/ICourse';
import { useAuthenticationContext } from './authenticationprovider';
export const AssignmentsContext = createContext<IAssignmentContext>({ Pending: true, SetSelectedAssignment: () => undefined });
export function useAssignmentContext() {
    return useContext(AssignmentsContext);
}

export interface IAssignmentContext extends IApiContext<IAssignment[]> {
    SelectedAssignment?: IAssignment;
    SetSelectedAssignment: (assignment?: IAssignment) => void;
}

export function AssignmentsProvider({ children, course, assignmentName }: PropsWithChildren<{ course: ICourse, assignmentName?: string; }>) {

    const authContext = useAuthenticationContext();
    const [assignments, setAssignments] = useState<IAssignment[]>();
    const [error, setError] = useState();
    const [pending, setPending] = useState(true);
    const [selectedAssignment, setSelectedAssignment] = useState<IAssignment | undefined>();

    useEffect(() => {
        setError(undefined);
        if(authContext.Result?.IsAuthenticated)
        {
            getAssignments(course, authContext.Result).then(assignments => {
                setAssignments(assignments);                
                setSelectedAssignment(assignments.find(a => a.Name === assignmentName));                
            }).catch(err => {
                setError(err);
            }).finally(() => {
                setPending(false);
            });
        }
    }, [course, authContext]);
    return (
        <AssignmentsContext.Provider value={{ Error: error, Pending: pending, Result: assignments, SelectedAssignment: selectedAssignment, SetSelectedAssignment: setSelectedAssignment }}>
            {children}
        </AssignmentsContext.Provider>
    );
}